import { useLocation, useNavigate, useParams } from 'react-router-dom';

/**
 * Hook personalizado para navegación multi-tenant
 * Automáticamente incluye el código del tenant en las rutas
 */
export const useTenantNavigation = () => {
  const navigate = useNavigate();
  const { codigo } = useParams();
  const location = useLocation();

  /**
   * Obtiene el código del tenant desde:
   * 1. Los params de la URL actual
   * 2. El localStorage
   * 3. La ruta actual
   */
  const getTenantCode = () => {
    // 1. Si ya está en los params, usarlo
    if (codigo) return codigo;

    // 2. Intentar desde localStorage
    const tenant = localStorage.getItem('tenant');
    if (tenant) {
      try {
        const tenantObj = JSON.parse(tenant);
        if (tenantObj.slug) return tenantObj.slug;
      } catch (e) {}
    }

    // 3. Extraer de la URL actual
    const pathParts = location.pathname.split('/').filter(p => p);
    const reservedRoutes = ['super-admin', 'login', 'api'];

    if (pathParts.length > 0 && !reservedRoutes.includes(pathParts[0])) {
      return pathParts[0];
    }

    // Por defecto, usar 'invramirez'
    return 'invramirez';
  };

  /**
   * Navega a una ruta incluyendo el código del tenant
   * @param {string} path - Ruta relativa (ej: '/clientes' o 'clientes/123/editar')
   * @param {object} options - Opciones de navegación (replace, state, etc.)
   */
  const tenantNavigate = (path, options = {}) => {
    const tenantCode = getTenantCode();

    // Limpiar el path (quitar / inicial si existe)
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;

    // Construir la ruta completa con el código del tenant
    const fullPath = `/${tenantCode}/${cleanPath}`;

    navigate(fullPath, options);
  };

  /**
   * Genera una ruta con el código del tenant incluido
   * @param {string} path - Ruta relativa
   * @returns {string} - Ruta completa con código del tenant
   */
  const getTenantPath = (path) => {
    const tenantCode = getTenantCode();
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return `/${tenantCode}/${cleanPath}`;
  };

  return {
    navigate: tenantNavigate,
    tenantNavigate, // Alias para mayor claridad
    getTenantPath,
    tenantCode: getTenantCode()
  };
};
